import ApiEnum from "../../constants/ApiEnum";

export default class DataEffect {

    static async requestData() {

        return await fetch(ApiEnum.Api + '/get-data/', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
                return response.json()
            }
        ).then((response) => {

            return {
                dateTime: response.dateTime,
                form: response.form,
                wishes: response.wishes,
                checkmark: response.checkmark,
                error: response.status
            }
        }).catch(function (error) {
            return {
                error: true,
                message: error.message
            }
        })
    }

    static async submitHandler(values) {

        return await fetch(ApiEnum.Api + '/process-data/', {
            method: 'post',
            body: JSON.stringify(values),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
                return response.json()
            }
        )

    }

    static async setMonthData(data) {

        return{
            selectedMonth: data.selectedMonth,
            selectedYear: data.selectedYear
        }

    }

    static async setDayData(data) {
        return{
            selectedDayName: data.selectedDayName,
            selectedDayNum: data.selectedDayNum
        }
    }

    static async setTimeData(data) {
        return{
            selectedTime: data.selectedTime
        }
    }

    static async setOptionData(data) {
        return{
            selectedOptions: data
        }
    }

    static async setRemarkData(data) {
        return{
            selectedRemark: data
        }
    }

    static async nextStep() {
        return true
    }

    static async navStep(step) {
        return{
            locatingStep: step
        }
    }

}
